import { ReactNode } from 'react';
import BgNsPanel from '@britishgasenergy/react-nucleus/dist/nuc-components/NsPanel';

type NsPanelProps = {
  children?: ReactNode;
  testId?: string;
  className?: string;
  decoration?: JSX.IntrinsicElements['ns-panel']['decoration'];
};

export const NsPanel = ({
  children,
  testId,
  decoration,
  className,
  ...rest
}: NsPanelProps) => {
  return (
    <BgNsPanel
      data-testid={testId}
      decoration={decoration}
      {...{ class: className }}
      {...rest}
    >
      {children}
    </BgNsPanel>
  );
};
